<div class="d-flex" [ngClass]="customClass" style="white-space: pre">
  <span>{{ value }}%</span>
</div>
